import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';

window.addEventListener('error', (e) => {
  console.error('GLOBAL ERROR:', e.error || e.message);
});
window.addEventListener('unhandledrejection', (e) => {
  console.error('UNHANDLED REJECTION:', e.reason);
});

const el = document.getElementById('root');

if (!el) {
  document.body.innerHTML = '<h1 style="color:red;padding:40px;font-family:sans-serif">ERROR: #root not found</h1>';
} else {
  try {
    createRoot(el).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log('App mounted OK');
  } catch (err) {
    console.error('MOUNT FAILED:', err);
    document.body.innerHTML =
      '<pre style="padding:20px;color:#991b1b;background:#fef2f2;white-space:pre-wrap;font-family:monospace;font-size:13px">' +
      (err.message || String(err)) + '\n\n' + (err.stack || '') +
      '</pre>';
  }
}
